<template>

    <input type="text" :placeholder="placeholder" v-model="model" class="input" />

</template>

<script>

export default {

    props: ['value', 'type', 'rule'],

    data: function() {

        return {
            model: ''
        }

    },

    created: function() {

        this.model = this.value

    },

    computed: {

        placeholder: function() {

            return this.type.lang.placeholder || 'Enter value'

        }

    },

    watch: {

        value: function(n) {

            this.model = n

        },

        model: function(n) {

            this.$emit('input', n)

        }

    }

}

</script>

<style scoped>

.input {
    background-color: #fff;
    border-radius: 4px;
    font-size: 14px;
    color: #333;
    height: 40px;
    width: 40px;
    font-weight: 400;
    text-align: left;
    padding: 0px 10px;
    width: 100%;
}

.is-mobile .input {
    border: 1px solid #eee;
}

.input::placeholder {
    color: #999;
}

</style>